
const languages = {
    en: require('./locales/en.json'),
    tr: require('./locales/tr.json')
}

export default languages;